<template>
  <div>
    <LicenceDetailItem style="margin: 24px;" v-if="detailLicense" :licence="detailLicense" @reload="loadData"
                       :super-admin="true"/>
    <div v-else>
      <v-data-iterator
          :items="licences"
          item-key="name"
          :items-per-page="200"
          hide-default-footer
      >
        <template v-slot:default="{ items }">
          <v-row>
            <v-col
                v-for="licence in items"
                :key="licence.course.id"
                cols="12"
                sm="12"
                md="6"
                lg="4"
                xl="3">
              <CompanyLicenceItem :super-admin="true" @reload="loadData" :licence="licence"
                                  @details="emitDetail(licence)"/>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
      <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>Gespeichert</v-snackbar>
      <v-snackbar :timeout="5000" :value="error" color="error" left shaped top>Fehler.</v-snackbar>
    </div>
  </div>
</template>

<script>
import CompanyLicenceItem from "@/components/CompanyLicenceItem";
import LicenceDetailItem from "@/components/LicenceDetailItem";
import License from "@/models/License";

export default {
  name: "SuperAdminCompanyCourseSettings",
  components: {LicenceDetailItem, CompanyLicenceItem},
  props: {
    companyId: {
      type: String
    },
    detailLicense: {
      type: License,
      default: null
    }
  },
  data: () => ({
    licences: [],
    loading: false,
    success: false,
    error: false
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    emitDetail(licence) {
      this.$emit("detail", licence)
    },
    loadData() {
      this.$httpLicenseApi.getSuperAdmin(this.companyId, (licences) => {
        this.licences = licences;
        this.emitDetail(licences.find(element => element.id === this.detailLicense.id))
      });
    },
  }
}
</script>

